export default {
  // 广告管理接口
  getStatusList: {
    url: '/shop/getStatusList',
    method: 'post',
    desc: '获取店铺广告授权状态'
  },
  portfolio: {
    url: '/operationads/report/portfolio',
    method: 'post',
    desc: '一级广告组合初始接口'
  },
  addPortfolio: {
    url: '/portfolio/addPortfolio',
    method: 'post',
    desc: '一级广告组合-新增接口'
  },
  editPortfolio: {
    url: '/portfolio/editPortfolio',
    method: 'post',
    desc: '一级广告组合-编辑'
  },
  portfolioList: {
    url: '/operationads/report/portfolio/list ',
    method: 'post',
    desc: '一级广告组合-广告组合筛选框options'
  },
  campaign: {
    url: '/operationads/report/campaign',
    method: 'post',
    desc: '所有广告活动'
  },
  adsHourActivityList: {
    url: '/operationhourads/adsHourActivityList',
    method: 'post',
    desc: '广告活动-分析-小时数据'
  },
  adsDaylyActivityList: {
    url: '/operationhourads/adsDaylyActivityList',
    method: 'post',
    desc: '广告活动-分析-日数据'
  },
  getHourBudgetTotal: {
    url: '/operationhourads/getHourBudgetTotal',
    method: 'post',
    desc: '广告活动-分析-预算分析汇总'
  },

  getHourBudgetDetail: {
    url: '/operationhourads/getHourBudgetDetail',
    method: 'post',
    desc: '广告活动-分析-预算分析明细'
  },
  campaignList: {
    url: '/operationads/report/campaign/list',
    method: 'post',
    desc: '所有广告活动'
  },
  campaignAdd: {
    url: '/operationads/report/campaign/add',
    method: 'post',
    desc: '广告活动（新增）'
  },
  profilesModify: {
    url: '/operationads/report/profiles/modify',
    method: 'post',
    desc: '广告活动（sp总预算设置）'
  },
  brandsList: {
    url: '/operationads/campaign/brands/list',
    method: 'post',
    desc: '广告活动-新建sb广告-获取品牌列表'
  },
  storesList: {
    url: '/operationads/campaign/stores/list',
    method: 'post',
    desc: '广告活动-新建sb广告-获取着陆页options'
  },
  storesAssetsList: {
    url: '/operationads/campaign/stores/assets/list',
    method: 'post',
    desc: '广告活动-新建sb广告-素材库图片列表'
  },
  campaignModify: {
    url: '/operationads/report/campaign/modify',
    method: 'post',
    desc: '广告活动（修改）'
  },
  launche: {
    url: '/operationads/report/launche',
    method: 'post',
    desc: '一级投放'
  },
  launcheModify: {
    url: '/operationads/report/launche/modify',
    method: 'post',
    desc: '一级投放-修改状态'
  },
  negativeTargetModify: {
    url: '/operationads/report/negativeTargets/modify',
    method: 'post',
    desc: '否定投放（修改）'
  },
  targetAdd: {
    url: '/operationads/report/searchSeek/target/add',
    method: 'post',
    desc: '一级搜索词-添加投放'
  },
  negativeTargetAdd: {
    url: '/operationads/report/searchSeek/negativeTarget/add',
    method: 'post',
    desc: '一级搜索词-添加否定投放'
  },
  keywordAdd: {
    url: '/operationads/report/searchSeek/keyword/add',
    method: 'post',
    desc: '一级搜索词-添加关键词'
  },
  negativeKeywordAdd: {
    url: '/operationads/report/searchSeek/negativeKeyword/add',
    method: 'post',
    desc: '一级搜索词-添加否词'
  },
  adGroups: {
    url: '/operationads/report/adGroups',
    method: 'post',
    desc: '二级广告组'
  },
  adGroupsList: {
    url: '/operationads/report/adGroups/list',
    method: 'post',
    desc: '二级广告组'
  },
  adGroupsAdd: {
    url: '/operationads/report/adGroups/add',
    method: 'post',
    desc: '二级广告组'
  },
  adGroupsModify: {
    url: '/operationads/report/adGroups/modify',
    method: 'post',
    desc: '广告组（修改）'
  },
  locationDate: {
    url: '/operationads/report/locationDate',
    method: 'post',
    desc: '二级广告位'
  },
  negativeCampaigns: {
    url: '/operationads/report/negative/campaign',
    method: 'post',
    desc: '二级否定投放'
  },
  // negativeCampaigns: {
  //   url: '/operationads/report/negative/campaign/add',
  //   method: 'post',
  //   desc: '二级否定投放-关键词新增'
  // },
  negativeCampaignModify: {
    url: '/operationads/report/negative/campaign/modify',
    method: 'post',
    desc: '二级否定投放(修改)'
  },
  productAds: {
    url: '/operationads/report/productAds',
    method: 'post',
    desc: '三级广告'
  },
  productAdsAdd: {
    url: '/operationads/report/productAds/add',
    method: 'post',
    desc: '三级广告(新增)'
  },
  getAsinList: {
    url: '/operationads/report/getAsinList',
    method: 'post',
    desc: '三级广告(新增)-asin查询'
  },
  getOnSaleAsinList: {
    url: '/operationads/report/getOnSaleAsinList',
    method: 'post',
    desc: '三级广告(新增)-asin查询-New'
  },
  productAdsModify: {
    url: '/operationads/report/productAds/modify',
    method: 'post',
    desc: '三级广告(修改)'
  },
  ads: {
    url: '/operationads/report/ads',
    method: 'post',
    desc: '三级广告-sb'
  },
  adsModify: {
    url: '/operationads/report/ads/modify',
    method: 'post',
    desc: '三级广告(修改)-sb'
  },
  keyWords: {
    url: '/operationads/report/keyWords',
    method: 'post',
    desc: '三级投放-关键词'
  },
  keywordsRecommendation: {
    url: '/operationads/keyword/bid/recommendation',
    method: 'post',
    desc: '三级投放-关键词-建议竞价'
  },
  keywordsAdd: {
    url: '/operationads/report/keywords/add',
    method: 'post',
    desc: '三级投放-关键词(新增)'
  },
  keywordsModify: {
    url: '/operationads/report/keywords/modify',
    method: 'post',
    desc: '三级投放-关键词（修改）'
  },
  targets: {
    url: '/operationads/report/targets',
    method: 'post',
    desc: '三级投放-类目&商品'
  },
  targetRecommendation: {
    url: '/operationads/target/bid/recommendation',
    method: 'post',
    desc: '三级投放-类目&商品-建议竞价'
  },
  targetsModify: {
    url: '/operationads/report/targets/modify',
    method: 'post',
    desc: '投放（修改）'
  },
  targetsAdd: {
    url: '/operationads/report/targets/add',
    method: 'post',
    desc: '三级投放-商品(新增)'
  },
  searchSeek: {
    url: '/operationads/report/searchSeek',
    method: 'post',
    desc: '搜索词页面初始接口'
  },
  negativeTargets: {
    url: '/operationads/report/negative/targets',
    method: 'post',
    desc: '三级否定投放-否定商品'
  },
  negativeTargetsAdd: {
    url: '/operationads/report/negativeTargets/add',
    method: 'post',
    desc: '否定商品(新增)'
  },
  negativeKeywords: {
    url: '/operationads/report/negative/keywords',
    method: 'post',
    desc: '三级否定投放-否定关键词'
  },
  negativeKeywordsAdd: {
    url: '/operationads/report/negativeKeywords/add',
    method: 'post',
    desc: '三级否定投放-否定关键词(新增)'
  },
  negativeKeywordsModify: {
    url: '/operationads/report/negative/keywords/modify',
    method: 'post',
    desc: '三级否定投放-否定关键词(修改)'
  },
  asins: {
    url: '/operationads/report/asins',
    method: 'post',
    desc: '三级购买ASIN初始接口'
  }
}
